export const socialMediaData = [
  {
    name: 'facebook',
    href: 'https://www.facebook.com/PolicyGenius',
  },
  {
    name: 'twitter',
    href: 'https://twitter.com/policygenius',
  },
  {
    name: 'linkedin',
    href: 'https://www.linkedin.com/company/policygenius',
  },
  {
    name: 'googlePlus',
    href: 'https://plus.google.com/+Policygenius',
  },
  {
    name: 'pinterest',
    href: 'https://www.pinterest.com/policygenius',
  },
];



// WEBPACK FOOTER //
// ../src/templates/Footer/data/socialMediaData.js